/* ============================================================
   POPUP «PRUEBA TU SUERTE» (misión 07l) · juego de memoria 3×3, port a Horizon del pop-up de Agua Cero.
   Flujo: cartas boca abajo → junta 3 iguales (siempre se gana: la 3.ª igual sale en el 3.º o 4.º toque) → «Ganaste X» →
   pregunta de 1 toque (opcional) → correo → listo (el paso de WhatsApp existe, pero va apagado: ajuste whatsapp_activo). El premio ya viene en la oferta de la página: NO hay código de
   descuento (la Function de la promo no se combina con códigos). Al reclamar solo se guarda el atributo oculto del
   carrito _popup_juego = <premio>|reclamo.
   Cuándo sale: una vez por sesión, a los N segundos VISIBLES en la página, o antes si en móvil sube rápido el scroll
   (gesto de «me voy») o en escritorio el cursor sale por arriba. Nunca encima de otro modal (drawers y diálogos de
   Horizon, pop-up de Priority+, pop-up de colores del 2x1, loader, formularios de Klaviyo) ni a quien ya reclamó.
   En qué páginas: lo decide el Liquid (sections/skindion-popup-juego.liquid); en las demás este archivo ni se carga.
   Pruebas: ?juego=1 lo abre ya · ?juego_dry=1 no llama a Klaviyo · ?nopopup=1 lo apaga · localStorage.removeItem('pjJuego') lo reinicia.
   Toda la configuración llega por los data-* de #PopupJuegoCfg.
   ============================================================ */
(function () {
  'use strict';
  var CFG = document.getElementById('PopupJuegoCfg');
  if (!CFG || window.PopupJuego) return;
  var D = CFG.dataset, H = document.documentElement;
  var bandera = function (k) { return new RegExp('(?:^|[?&])' + k + '=1(?:&|$)').test(location.search); };
  var FORZADO = bandera('juego'), DRY = bandera('juego_dry'), NOPOP = bandera('nopopup');
  var EDITOR = D.editor === '1';
  var txt = function (k, def) { var v = String(D[k] || '').trim(); return v || def; };
  var PREMIO = txt('premio', '50% OFF');
  var PREMIO_ID = txt('premioId', '');
  var LANDING = txt('landing', '');
  var EXTRA = txt('extra', '');
  var OTROS = txt('otros', 'Envío gratis|Regalo Sorpresa|$100 OFF').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
  while (OTROS.length < 3) OTROS.push(PREMIO);
  var PCT = parseInt(D.pct, 10); if (!(PCT >= 0 && PCT <= 100)) PCT = 100;
  var ESPERA = Math.max(3, parseInt(D.espera, 10) || 3) * 1000;
  /* list: la lista general del pop-up · listaPromo: la de la audiencia de la promo de la página (50% / 2x1) */
  var KL = { company: txt('klaviyoCompany', ''), list: txt('klaviyoLista', ''), listaPromo: txt('klaviyoListaPromo', ''), base: 'https://a.klaviyo.com/client/' };
  var MED_URL = txt('medir', '');
  var RAIZ = '/'; try { if (window.Shopify && Shopify.routes && Shopify.routes.root) RAIZ = Shopify.routes.root; } catch (e) {}
  var KEY = 'pjJuego', KEY_SES = 'pjJuegoVisto';
  var RM = false; try { RM = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var MOVIL = false; try { MOVIL = matchMedia('(pointer: coarse)').matches; } catch (e) {}
  /* opciones de la pregunta: una por renglón en el ajuste; sin opciones se salta directo al correo */
  var OPCIONES = String(D.opciones || '').split(/\r?\n/).map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 4);
  /* recibo de «¡Listo!»: un beneficio por renglón, «texto|estado» (p. ej. «50% OFF|Aplicado»); sin renglones, solo el texto */
  var RECIBO = String(D.recibo || '').split(/\r?\n/).map(function (s) { return s.split('|').map(function (x) { return x.trim(); }); }).filter(function (r) { return r[0]; }).slice(0, 5);

  /* ---------- memoria del visitante (todo con try/catch: modo privado, bloqueos) ---------- */
  function lee() { try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } }
  function guarda(o) { var s = lee(); for (var k in o) s[k] = o[k]; try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} return s; }
  function sesion(v) { try { if (v) sessionStorage.setItem(KEY_SES, v); return sessionStorage.getItem(KEY_SES); } catch (e) { return null; } }
  /* el brazo A/B sale de un número fijo por visitante: estable entre visitas y monótono si cambia el % */
  var MEM = lee();
  if (!(MEM.u >= 0 && MEM.u < 1)) MEM = guarda({ u: Math.random(), desde: new Date().toISOString() });
  function brazo() { return MEM.u * 100 < PCT ? 'juego' : 'control'; }
  function reclamado() { return !!lee().rec; }

  /* ---------- medición: dataLayer (GA4/GTM) + evento del navegador + POST opcional; nada sale antes del primer toque humano.
     Cada evento popup_juego_<paso> lleva premio y landing (tasa de registro = reclama ÷ visto, por landing). Nunca datos
     personales: el correo no entra a ningún evento ni a la URL de medición (docs/popup-juego.md). ---------- */
  function sid() {
    var k = 'pj_sid', s = null;
    try { s = sessionStorage.getItem(k); } catch (e) {}
    if (!s) { s = Date.now().toString(36) + Math.random().toString(36).slice(2, 8); try { sessionStorage.setItem(k, s); } catch (e) {} }
    return s;
  }
  var cola = [], humano = false, dados = {};
  function enviar(ev, md) {
    md.premio = PREMIO_ID; md.landing = LANDING;
    md.brazo = brazo(); md.pct = PCT;
    if (FORZADO) md.forzado = 1;
    if (DRY) md.dry = 1;
    try { if (window.Shopify && Shopify.theme && Shopify.theme.role) md.role = Shopify.theme.role; } catch (e) {}   /* 'main' = tema publicado */
    try { document.dispatchEvent(new CustomEvent('popup-juego', { detail: { evento: ev, datos: md } })); } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'popup_juego_' + ev, popup_juego: md }); } catch (e) {}
    if (!MED_URL) return;
    try {
      fetch(MED_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
        body: JSON.stringify({ session_id: sid(), event: 'popup_juego_' + ev, metadata: md, page_path: location.pathname }) }).catch(function () {});
    } catch (e) {}
  }
  function medir(ev, md, clave) {
    var id = ev + '|' + (clave == null ? '' : clave);
    if (dados[id]) return; dados[id] = 1;
    if (humano) enviar(ev, md || {}); else cola.push([ev, md || {}]);
  }
  function alHumano(e) {
    if (humano || (e && e.isTrusted === false)) return;
    humano = true; cola.splice(0).forEach(function (x) { enviar(x[0], x[1]); });
  }
  ['pointerdown', 'keydown', 'touchstart', 'scroll'].forEach(function (t) { addEventListener(t, alHumano, { passive: true, capture: true }); });
  /* el brazo A/B solo se mide si hay grupo de control (% de visitantes < 100) */
  if (PCT < 100) (function () { var k = 'pjJuegoAB', ya = null; try { ya = sessionStorage.getItem(k); } catch (e) {}
    if (!ya) { medir('ab', { u: Math.round(MEM.u * 1000) / 1000 }); try { sessionStorage.setItem(k, '1'); } catch (e) {} } })();

  /* ---------- utilidades ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function conTiempo(p, ms) { return Promise.race([p, new Promise(function (_, no) { setTimeout(function () { no(new Error('tiempo')); }, ms); })]); }
  function jpost(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body || {}) })
      .then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }
  function vibra(p) { try { navigator.vibrate && navigator.vibrate(p); } catch (e) {} }
  /* teléfono de México a E.164: 10 dígitos (la lada nunca empieza en 0 ni en 1), con o sin +52 / +52 1. Si no cuadra, '' */
  function telefono(v) {
    var s = String(v == null ? '' : v).trim();
    if (/[a-z]/i.test(s)) return '';
    var d = s.replace(/\D/g, '');
    if (d.length === 13 && d.indexOf('521') === 0) d = d.slice(3);
    else if (d.length === 12 && d.indexOf('52') === 0) d = d.slice(2);
    return /^[2-9]\d{9}$/.test(d) ? '+52' + d : '';
  }
  /* bajo el correo: el texto y el enlace de Mau */
  function legalCorreoHtml() {
    return '<p class="pj-legal">' + esc(txt('legal', 'Al dejar tu correo aceptas recibir correos de Skindion. Te das de baja cuando quieras.')) +
      (D.privacidad ? ' <a href="' + esc(D.privacidad) + '" target="_blank" rel="noopener">Aviso de privacidad</a>' : '') + '</p>';
  }
  /* bajo el WhatsApp (paso apagado): solo los enlaces. Antes de reactivarlo hay que revisar el consentimiento de WhatsApp. */
  function legalWhatsappHtml() {
    return '<p class="pj-legal">Ver <a href="' + esc(txt('terminos', '/policies/terms-of-service')) + '" target="_blank" rel="noopener">Términos</a> y <a href="' + esc(txt('privacidad', '/policies/privacy-policy')) + '" target="_blank" rel="noopener">Aviso de privacidad</a>.</p>';
  }
  var ICO_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICO_OK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg>';
  /* íconos de las respuestas, por orden (B5, elección de Mau del 2026-11-03): 1 firmeza (flecha arriba), 2 líneas
     (destello), 3 desinflamar (gota), 4 regalo. El color de cada uno está en el CSS (.pj-opt:nth-child). */
  var ICONOS_OPC = [
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20V5M6.5 10.5L12 5l5.5 5.5"/></svg>',
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3c.8 4.4 3.6 7.2 8 8-4.4.8-7.2 3.6-8 8-.8-4.4-3.6-7.2-8-8 4.4-.8 7.2-3.6 8-8z"/></svg>',
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3.5s6 6.3 6 10.5a6 6 0 0 1-12 0c0-4.2 6-10.5 6-10.5z"/></svg>',
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M5 12v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8M12 8v13M12 8S10.5 3.5 8 4.2C6 4.8 6.6 8 9 8M12 8s1.5-4.5 4-3.8c2 .6 1.4 3.8-1 3.8"/></svg>'
  ];
  var ICO_FLECHA = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  /* ---------- ¿se puede abrir ahora? nunca encima de otro modal ----------
     Horizon marca html[scroll-lock] mientras hay un drawer o diálogo suyo abierto (carrito, menú, búsqueda, quick add,
     chat). Los pop-ups propios (Priority+, colores del 2x1) son <dialog> con showModal. El loader marca
     html[data-skd-loading] o un [data-skd-loader] visible. Los formularios de Klaviyo son [aria-modal="true"] con
     aria-label «POPUP Form» / «FULLSCREEN Form» (medido en el live, docs/popup-juego.md). Un elemento cuenta si se ve:
     tamaño, visibilidad, opacidad y dentro de la pantalla (un sheet escondido fuera de pantalla no bloquea). */
  var SEL_MODAL = '[aria-modal="true"], dialog[open], details.menu-drawer-container[open], [data-skd-loader], .skd-loader, [class*="kl-private-reset-css"][role="dialog"]';
  function seVe(m) {
    var r = m.getBoundingClientRect(), cs = getComputedStyle(m);
    if (r.width <= 40 || r.height <= 40 || cs.visibility === 'hidden' || cs.display === 'none' || parseFloat(cs.opacity) <= 0.05) return false;
    return r.bottom > 0 && r.right > 0 && r.top < innerHeight && r.left < innerWidth;
  }
  function bloqueado() {
    /* forzado (?juego=1, PopupJuego.abre()): solo cuenta un formulario de Klaviyo que siga abierto en pantalla */
    if (klaviyoVisto && !FORZADO) return 'klaviyo';
    if (H.hasAttribute('scroll-lock')) return 'horizon';
    if (H.hasAttribute('data-skd-loading')) return 'loader';
    var ms = document.querySelectorAll(SEL_MODAL);
    for (var i = 0; i < ms.length; i++) {
      var m = ms[i]; if (m.closest('.pj')) continue;
      if (seVe(m)) return /kl-private-reset-css/.test(m.className) || / Form$/.test(m.getAttribute('aria-label') || '') ? 'klaviyo' : 'modal';
    }
    return '';
  }
  /* un formulario emergente de Klaviyo que se abre en esta visita apaga el juego por toda la sesión (dos pop-ups no) */
  var klaviyoVisto = false;
  addEventListener('klaviyoForms', function (e) {
    var t = e && e.detail && e.detail.type;
    if (t !== 'open' || abierto) return;
    klaviyoVisto = true;
    if (!FORZADO && !hecho) { hecho = true; sesion('klaviyo'); medir('omitido', { motivo: 'klaviyo' }); }
  });

  /* ---------- precarga perezosa: CSS + imágenes (nada compite con la carga de la página) ---------- */
  var listo = null;
  function precarga() {
    if (listo) return listo;
    var css = new Promise(function (ok) {
      if (!D.css || document.querySelector('link[data-pj]')) return ok();
      var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = D.css; l.setAttribute('data-pj', '1');
      l.onload = l.onerror = function () { ok(); }; document.head.appendChild(l);
    });
    var imgs = [D.imagen, D.logo].filter(Boolean).map(function (src) {
      return new Promise(function (ok) {
        var im = new Image(); im.decoding = 'async'; try { im.fetchPriority = 'low'; } catch (e) {}
        im.onload = function () { (im.decode ? im.decode() : Promise.resolve()).then(ok, ok); }; im.onerror = function () { ok(); }; im.src = src;
      });
    });
    listo = Promise.race([Promise.all([css].concat(imgs)), new Promise(function (ok) { setTimeout(ok, 3500); })]);
    return listo;
  }

  /* ---------- disparadores ---------- */
  var abierto = false, intentando = false, hecho = false, visible = 0, cerrarActual = null;
  function intenta(motivo) {
    if (abierto || intentando || hecho) return;
    if (!FORZADO) {
      if (NOPOP) { hecho = true; return; }
      var s = lee(); if (s.rec || (s.jugo && s.vuelta)) { hecho = true; return; }   /* jugó y no reclamó: una vuelta más (abre) */
      if (sesion()) { hecho = true; return; }
    }
    var b = bloqueado();
    if (b) {
      if (b === 'klaviyo' && !FORZADO) { klaviyoVisto = true; hecho = true; sesion('klaviyo'); medir('omitido', { motivo: 'klaviyo' }); return; }
      intentando = true; setTimeout(function () { intentando = false; intenta(motivo); }, 2500); return;
    }
    intentando = true;
    if (!FORZADO && brazo() !== 'juego') { intentando = false; hecho = true; medir('elegible', { motivo: motivo }); return; }
    medir('elegible', { motivo: motivo });
    precarga().then(function () {
      /* se abre en un momento ocioso del hilo principal (tope 1.2 s): armar el pop-up no compite con la página (TBT) */
      enOcio(function () {
        intentando = false;
        if (bloqueado()) return setTimeout(function () { intenta(motivo); }, 2500);
        abre(FORZADO ? 'forzado' : motivo);
      });
    });
  }
  function enOcio(fn) { if (window.requestIdleCallback) requestIdleCallback(fn, { timeout: 1200 }); else setTimeout(fn, 0); }
  if (!NOPOP && !EDITOR) {
    /* tiempo VISIBLE en la página (una pestaña en segundo plano no cuenta); CSS e imágenes se piden ~1.5 s antes */
    var reloj = setInterval(function () {
      if (hecho || abierto) return clearInterval(reloj);
      if (!document.hidden) visible += 500;
      if (visible >= Math.max(1500, ESPERA - 1500) && document.readyState === 'complete') precarga();
      if (visible >= (FORZADO ? 600 : ESPERA)) intenta('tiempo');
    }, 500);
    /* móvil: sube rápido el scroll después de haber bajado (gesto típico de «me voy»). En Horizon, a partir de 990 px
       el que se desplaza es .page-wrapper y no la ventana: se escuchan los dos (captura en document). */
    var maxY = 0, lastY = 0, subida = 0, subeDesde = 0;
    document.addEventListener('scroll', function (e) {
      var el = e.target, y;
      if (el === document || el === document.documentElement || el === document.body) y = window.scrollY || 0;
      else if (el && el.classList && el.classList.contains('page-wrapper')) y = el.scrollTop;
      else return;
      var t = Date.now();
      if (y > maxY) maxY = y;
      if (y < lastY) { if (!subida) subeDesde = t; subida += lastY - y; } else { subida = 0; }
      lastY = y;
      if (MOVIL && maxY > 600 && visible >= 4000 && subida > 180 && t - subeDesde < 380) intenta('scroll');
    }, { passive: true, capture: true });
    /* escritorio: el cursor sale por arriba de la ventana */
    document.addEventListener('mouseout', function (e) { if (!MOVIL && !e.relatedTarget && e.clientY <= 0 && visible >= 4000) intenta('salida'); });
  }
  /* editor del theme: no sale solo; se abre al seleccionar la sección en la barra lateral y se cierra al soltarla */
  if (EDITOR) {
    document.addEventListener('shopify:section:select', function (e) { if (e.detail && e.detail.sectionId === D.section) window.PopupJuego.abre(); });
    document.addEventListener('shopify:section:deselect', function (e) { if (e.detail && e.detail.sectionId === D.section && cerrarActual) cerrarActual('editor'); });
  }

  /* ---------- el reparto amañado: siempre se gana y la 3.ª igual sale en el 3.º o el 4.º toque ---------- */
  var CLAVES = ['a', 'b', 'c', 'd'];
  function reparto(rnd) {
    var W = CLAVES[Math.floor(rnd() * 4)];
    var otros = CLAVES.filter(function (k) { return k !== W; });
    var X = otros[Math.floor(rnd() * 3)];
    return { W: W, plan: rnd() < 0.25 ? [W, W, W] : [W, X, W, W], mazo: [W, W, W].concat(otros, otros) };   /* 3 del ganador + 2 de cada otro = 9 */
  }
  /* el ganador lleva PREMIO; los otros tres, los premios menores del ajuste «otros» */
  function cara(k, W) { if (k === W) return PREMIO; var o = CLAVES.filter(function (x) { return x !== W; }); return OTROS[o.indexOf(k)] || PREMIO; }
  var ESTRELLA = '<svg viewBox="0 0 40 40" aria-hidden="true"><path d="M20 2c1.6 9.3 8.7 16.4 18 18-9.3 1.6-16.4 8.7-18 18-1.6-9.3-8.7-16.4-18-18 9.3-1.6 16.4-8.7 18-18z" fill="currentColor"/></svg>';
  /* contador bajo las cartas (pedido de Mau): «Tienes cuatro oportunidades» y baja con cada carta que escogen. El reparto
     gana a más tardar en el 4.º toque, así que nunca llega a cero: en la carta que gana sale «¡3 iguales!». */
  var CHANCES = 4, NUMEROS = ['cero', 'una', 'dos', 'tres', 'cuatro'];
  function oportunidades(n) { return 'Tienes <b>' + NUMEROS[n] + '</b> ' + (n === 1 ? 'oportunidad' : 'oportunidades'); }
  /* reverso de las cartas: marco interior de naipe y la «s» de skindion en la tipografía de títulos del theme (no el «?») */
  var DORSO = '<svg viewBox="0 0 72 100" aria-hidden="true" preserveAspectRatio="xMidYMid meet"><rect x="6" y="6" width="60" height="88" rx="6" fill="none" stroke="currentColor" stroke-opacity=".22" stroke-width="1"/>' +
    '<text x="36" y="50" dy=".34em" text-anchor="middle" fill="currentColor" style="font: 800 40px var(--pj-f-titulo)">s</text>' +
    '<circle cx="36" cy="80" r="2" fill="currentColor" fill-opacity=".45"/><circle cx="36" cy="20" r="2" fill="currentColor" fill-opacity=".45"/></svg>';

  /* ---------- fondo oculto al lector de pantalla mientras está abierto: aria-hidden en los hermanos (con aria-modal en el
     pop-up). El teclado ya queda dentro por la trampa de foco y el velo tapa clics y toques. No se usa inert: en la PDP
     (~2,900 nodos) recalcula el estilo de toda la página, 30–90 ms con CPU 4x al poner y al quitar (TBT); aria-hidden
     cuesta 3–7 ms (docs/popup-juego.md). Solo se quita lo que se puso. ---------- */
  var ocultos = [];
  function inerte(on) {
    if (on) {
      [].forEach.call(document.body.children, function (el) {
        if (el === R || el.tagName === 'SCRIPT' || el.hasAttribute('aria-hidden')) return;
        el.setAttribute('aria-hidden', 'true'); ocultos.push(el);
      });
    } else { ocultos.splice(0).forEach(function (el) { el.removeAttribute('aria-hidden'); }); }
  }

  /* ---------- el popup ---------- */
  var R, SHEET, foco = null;
  function abre(motivo) {
    if (abierto) return; abierto = true;
    sesion('1');
    foco = document.activeElement;
    var RP = reparto(Math.random), W = RP.W, plan = RP.plan, mazo = RP.mazo;
    var toques = 0, caras = [], bloqueo = false, t0 = performance.now(), respuesta = '', fase = 'juego';
    /* quien jugó y se fue sin dejar su correo: en su siguiente visita entra directo a «Tu premio sigue aquí», una sola vez */
    var vuelta = !FORZADO && !!lee().jugo && !lee().rec;
    if (vuelta) guarda({ vuelta: new Date().toISOString() });

    R = document.createElement('div'); R.className = 'pj' + (D.logo ? '' : ' pj--sinlogo'); R.setAttribute('role', 'dialog'); R.setAttribute('aria-modal', 'true'); R.setAttribute('aria-labelledby', 'pjT');
    var cartas = ''; for (var i = 0; i < 9; i++) cartas += '<button type="button" class="pj-card" style="--i:' + i + '" aria-label="Carta ' + (i + 1) + ', boca abajo"><span class="pj-in"><span class="pj-back" aria-hidden="true">' + DORSO + '</span><span class="pj-face" aria-hidden="true"><b></b></span></span></button>';
    var opciones = OPCIONES.map(function (t, k) { return '<button type="button" class="pj-opt pj-r' + (ICONOS_OPC[k] ? ' pj-opt--ico' : '') + '" style="--d:' + (k + 3) + '" data-v="' + esc(t) + '">' + (ICONOS_OPC[k] ? '<span class="pj-ico" aria-hidden="true">' + ICONOS_OPC[k] + '</span>' : '') + '<span>' + esc(t) + '</span></button>'; }).join('');
    /* recibo de «¡Listo!» (L2, elección de Mau del 2026-11-03): «Tu pedido» con cada beneficio y su estado */
    var recibo = RECIBO.length ? '<section class="pj-recibo pj-r" style="--d:2" aria-labelledby="pjRecibo"><h3 class="pj-recibo-t" id="pjRecibo">' + esc(txt('reciboTitulo', 'Tu pedido')) + '</h3><ul>' +
      RECIBO.map(function (r) { return '<li><span>' + esc(r[0]) + '</span>' + (r[1] ? '<em>' + ICO_OK + esc(r[1]) + '</em>' : '') + '</li>'; }).join('') + '</ul></section>' : '';
    var logo = D.logo ? '<img class="pj-logo" src="' + esc(D.logo) + '" alt="' + esc(txt('marca', '')) + '" width="112" height="28">' : '';
    R.innerHTML =
      '<div class="pj-bg"></div>' +
      '<div class="pj-sheet">' +
        '<button type="button" class="pj-x" aria-label="Cerrar">' + ICO_X + '</button>' +
        logo +
        '<section class="pj-step is-on" data-step="juego">' +
          '<h2 id="pjT" class="pj-t">' + esc(txt('titulo', 'Prueba tu suerte')) + '</h2>' +
          '<p class="pj-sub">' + esc(txt('subtitulo', 'Junta 3 iguales y descubre tu premio')) + '</p>' +
          '<div class="pj-grid" role="group" aria-label="Cartas">' + cartas + '</div>' +
          '<p class="pj-hint" aria-live="polite">' + oportunidades(CHANCES) + '</p>' +
          '<button type="button" class="pj-no">Ahora no</button>' +
        '</section>' +
        '<section class="pj-step" data-step="premio" hidden>' +
          '<p class="pj-won pj-r" style="--d:0">Ganaste</p>' +
          '<h2 class="pj-big pj-r" style="--d:1" tabindex="-1"><b>' + esc(PREMIO) + '</b>' + (EXTRA ? '<span>' + esc(EXTRA) + '</span>' : '') + '</h2>' +
          (OPCIONES.length ? '<p class="pj-qt pj-r" style="--d:2">' + esc(txt('pregunta', 'Cuéntanos, ¿qué buscas?')) + '</p><div class="pj-opts">' + opciones + '</div>'
            : '<button type="button" class="pj-cta pj-r" style="--d:2" data-sigue><span>Reclamar mi premio</span>' + ICO_FLECHA + '</button>') +
        '</section>' +
        '<section class="pj-step" data-step="correo" hidden>' +
          '<p class="pj-won pj-r" style="--d:0"><span class="pj-mresp"></span></p>' +
          '<h2 class="pj-t2 pj-r" style="--d:1" tabindex="-1">Tu ' + esc(PREMIO) + ' te espera</h2>' +
          '<p class="pj-sub pj-r" style="--d:1">Déjanos tu correo y lo dejamos listo en tu pedido.</p>' +
          '<form class="pj-form pj-r" style="--d:2" novalidate>' +
            '<label class="pj-field"><span class="pj-lbl">Tu correo</span><input type="email" name="email" autocomplete="email" inputmode="email" autocapitalize="off" spellcheck="false" placeholder="Escribe tu correo" required aria-describedby="pjErr"></label>' +
            '<p class="pj-err" id="pjErr" role="alert"></p>' +
            '<button type="submit" class="pj-cta"><span>Aplicar mi ' + esc(PREMIO) + '</span>' + ICO_FLECHA + '</button>' +
            legalCorreoHtml() +
          '</form>' +
        '</section>' +
        '<section class="pj-step" data-step="whatsapp" hidden>' +
          '<p class="pj-won pj-r" style="--d:0">Tu ' + esc(PREMIO) + ' ya está en tu pedido</p>' +
          '<h2 class="pj-t2 pj-r" style="--d:1" tabindex="-1">' + esc(txt('waTitulo', '¿Te lo mandamos también por WhatsApp?')) + '</h2>' +
          '<p class="pj-sub pj-r" style="--d:1">' + esc(txt('waTexto', 'Te avisamos de tu pedido y de ofertas que no salen en ningún otro lado.')) + '</p>' +
          '<form class="pj-form pj-form-wa pj-r" style="--d:2" novalidate>' +
            '<label class="pj-field"><span class="pj-lbl">Tu WhatsApp</span><span class="pj-tel"><span class="pj-pref" aria-hidden="true">+52</span>' +
              '<input type="tel" inputmode="tel" autocomplete="tel-national" name="whatsapp" placeholder="55 1234 5678" maxlength="20" aria-label="Tu WhatsApp, 10 dígitos, México más 52" aria-describedby="pjErrWa"></span></label>' +
            '<p class="pj-err" id="pjErrWa" role="alert"></p>' +
            '<button type="submit" class="pj-cta"><span>' + esc(txt('waBoton', 'Sí, mándamelo por WhatsApp')) + '</span>' + ICO_FLECHA + '</button>' +
            legalWhatsappHtml() +
            '<button type="button" class="pj-no" data-omite>Ahora no</button>' +
          '</form>' +
        '</section>' +
        '<section class="pj-step" data-step="listo" hidden>' +
          '<div class="pj-ok pj-r" style="--d:0" aria-hidden="true"><svg viewBox="0 0 52 52"><circle cx="26" cy="26" r="24"/><path d="M15 27l7.5 7.5L37.5 19"/></svg></div>' +
          '<h2 class="pj-t2 pj-r" style="--d:1" tabindex="-1">' + esc(txt('finalTitulo', '¡Listo! Ya está aplicado')) + '</h2>' +
          recibo +
          '<p class="pj-note pj-r" style="--d:3">' + esc(txt('finalTexto', '')) + '</p>' +
          /* en las landings solo cierra; en la home lleva a la promo (con flecha: cambia de página) */
          '<button type="button" class="pj-cta pj-r" style="--d:4" data-final><span>' + esc(txt('botonFinal', 'Seguir con mi compra')) + '</span>' + (txt('urlFinal', '') ? ICO_FLECHA : '') + '</button>' +
        '</section>' +
        '<div class="pj-deco" aria-hidden="true"><i class="pj-st1">' + ESTRELLA + '</i><i class="pj-st2">' + ESTRELLA + '</i>' +
          (D.imagen ? '<img class="pj-img" src="' + esc(D.imagen) + '" alt="" decoding="async">' : '') + '</div>' +
      '</div>';
    document.body.appendChild(R);
    SHEET = R.querySelector('.pj-sheet');
    medir('visto', { motivo: motivo, plan: plan.length, vuelta: vuelta ? 1 : 0 });
    /* lo que toca toda la página (bloqueo del scroll y fondo oculto) va en otra tarea, ya con la animación andando: dos
       tareas cortas en vez de una larga. El foco entra antes a la hoja: Chrome ignora aria-hidden si el foco sigue dentro
       de lo que se oculta. */
    SHEET.setAttribute('tabindex', '-1');
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      R.classList.add('is-on');
      setTimeout(function () {
        if (!vivo) return;
        try { SHEET.focus({ preventScroll: true }); } catch (e) {}
        H.classList.add('pj-on'); inerte(true);
      }, 0);
    }); });
    setTimeout(function () { try { SHEET.focus({ preventScroll: true }); } catch (e) {} }, RM ? 30 : 420);

    var $ = function (s) { return R.querySelector(s); }, $$ = function (s) { return [].slice.call(R.querySelectorAll(s)); };
    var cards = $$('.pj-card'), hint = $('.pj-hint');

    /* ---------- cerrar: X, Esc o el fondo ---------- */
    var vivo = true;
    function tecla(e) {
      if (e.key === 'Escape') { e.preventDefault(); cierra('esc'); return; }
      if (e.key !== 'Tab') return;
      var f = $$('button:not([disabled]), input, a[href], [tabindex]:not([tabindex="-1"])').filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && (document.activeElement === f[0] || !R.contains(document.activeElement) || document.activeElement === SHEET)) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && (document.activeElement === f[f.length - 1] || !R.contains(document.activeElement))) { e.preventDefault(); f[0].focus(); }
    }
    function cierra(como, luego) {
      if (!vivo) return; vivo = false; cerrarActual = null;
      medir('cierra', { fase: fase, como: como, toques: toques });
      document.removeEventListener('keydown', tecla, true);
      R.classList.remove('is-on'); R.classList.add('is-off');
      inerte(false);
      setTimeout(function () { H.classList.remove('pj-on'); R.remove(); abierto = false; hecho = true; if (luego) luego(); else if (foco && foco.focus) try { foco.focus({ preventScroll: true }); } catch (e) {} }, RM ? 60 : 420);
    }
    cerrarActual = cierra;
    document.addEventListener('keydown', tecla, true);
    $('.pj-x').addEventListener('click', function () { cierra('x'); });
    $('.pj-no').addEventListener('click', function () { cierra('ahora_no'); });
    $('.pj-bg').addEventListener('click', function () { cierra('fondo'); });

    /* ---------- cambiar de pantalla: en celular el foco va al título (sin abrir el teclado); en escritorio, al botón ---------- */
    function paso(nombre) {
      var h0 = SHEET.offsetHeight;
      $$('.pj-step').forEach(function (s) { var on = s.getAttribute('data-step') === nombre; s.hidden = !on; s.classList.toggle('is-on', on); s.classList.remove('is-in'); });
      fase = nombre;
      var h1 = SHEET.offsetHeight, nuevo = R.querySelector('[data-step="' + nombre + '"]');
      if (!RM && SHEET.animate && Math.abs(h1 - h0) > 2) SHEET.animate([{ height: h0 + 'px' }, { height: h1 + 'px' }], { duration: 460, easing: 'cubic-bezier(.22,1,.36,1)' });
      requestAnimationFrame(function () { requestAnimationFrame(function () { nuevo.classList.add('is-in'); }); });
      SHEET.scrollTop = 0;
      return nuevo;
    }
    function enfoca(paso, sel) {
      setTimeout(function () {
        var b = !MOVIL && sel ? paso.querySelector(sel) : null;
        b = b || paso.querySelector('h2[tabindex]');
        if (b) try { b.focus({ preventScroll: true }); } catch (e) {}
      }, RM ? 30 : 480);
    }

    /* ---------- el juego ---------- */
    function cuenta() { var n = {}; caras.forEach(function (k) { if (k) n[k] = (n[k] || 0) + 1; }); return n; }
    /* contador de oportunidades: baja al escoger la carta (el número late un instante, salvo con reduced motion) */
    function marcador(quedan, faltaUna, late) {
      hint.innerHTML = (faltaUna ? '¡Te falta una! ' : '') + oportunidades(quedan);
      var b = hint.querySelector('b');
      if (late && b && !RM && b.animate) b.animate([{ transform: 'scale(1.35)' }, { transform: 'none' }], { duration: 360, easing: 'cubic-bezier(.34,1.32,.5,1)' });
    }
    function voltea(card, k, quieto) {
      var idx = cards.indexOf(card); caras[idx] = k;
      var t = cara(k, W); card.querySelector('.pj-face b').textContent = t;
      card.classList.toggle('is-premio', k === W);
      card.setAttribute('aria-label', 'Carta ' + (idx + 1) + ': ' + t);
      card.classList.add('is-up'); if (quieto) card.classList.add('is-quieto');
      card.setAttribute('aria-disabled', 'true');
    }
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        if (bloqueo || fase !== 'juego' || card.classList.contains('is-up')) return;
        var k = plan[toques]; if (!k) return;
        toques++;
        if (toques === 1) { guarda({ jugo: new Date().toISOString() }); R.classList.add('is-jugando'); }
        medir('toque', { n: toques }, toques);
        vibra(6);
        voltea(card, k);
        bloqueo = true;
        var yaGana = cuenta()[W] >= 3;
        if (!yaGana) marcador(CHANCES - toques, false, true);
        setTimeout(function () {
          bloqueo = false;
          var n = cuenta();
          if (n[W] >= 3) return gana();
          if (n[W] === 2) { marcador(CHANCES - toques, true, false); cards.forEach(function (c, i) { c.classList.toggle('is-par', caras[i] === W); }); vibra([8, 40, 8]); }
        }, RM ? 80 : 470);
      });
    });

    if (vuelta) { $('[data-step="premio"] .pj-won').textContent = 'Tu premio sigue aquí'; enfoca(paso('premio'), '.pj-opt, [data-sigue]'); }

    function gana() {
      bloqueo = true; fase = 'gana';
      guarda({ gano: new Date().toISOString() });
      medir('gana', { toques: toques, ms: Math.round(performance.now() - t0) });
      hint.textContent = '¡3 iguales!';
      R.classList.add('is-gano');
      cards.forEach(function (c, i) { if (caras[i] === W) c.classList.add('is-match'); });
      vibra([12, 60, 24]);
      /* el resto del tablero se destapa solo, tenue: el reparto se ve completo */
      var resto = mazo.slice(); caras.forEach(function (k) { if (k) resto.splice(resto.indexOf(k), 1); });
      resto.sort(function () { return Math.random() - 0.5; });
      var j = 0;
      cards.forEach(function (c, i) { if (!caras[i]) { var k = resto[j++]; setTimeout(function () { voltea(c, k, true); }, RM ? 0 : 240 + j * 60); } });
      setTimeout(function () { enfoca(paso('premio'), '.pj-opt, [data-sigue]'); }, RM ? 400 : 1500);
    }

    /* ---------- pregunta → correo ---------- */
    function aCorreo() {
      $('.pj-mresp').textContent = respuesta;
      enfoca(paso('correo'), 'input[name="email"]');
    }
    $$('.pj-opt').forEach(function (b) {
      b.addEventListener('click', function () {
        respuesta = b.getAttribute('data-v') || '';
        b.classList.add('is-sel');
        medir('respuesta', { v: respuesta });
        setTimeout(aCorreo, RM ? 0 : 220);
      });
    });
    var sigue = $('[data-sigue]'); if (sigue) sigue.addEventListener('click', aCorreo);

    /* ---------- reclamar: Klaviyo y el atributo del carrito en paralelo. El premio no depende de ninguno de los dos: la
       pantalla final sale cuando el atributo queda guardado o a los 2.5 s, lo que pase primero, y nunca espera a Klaviyo
       (si Klaviyo falla, se mide el error y la clienta igual ve «¡Listo!»). ---------- */
    var enviando = false, correo = '';
    $('.pj-form').addEventListener('submit', function (e) {
      e.preventDefault();
      if (enviando) return;
      var err = $('.pj-err'), ie = $('input[name="email"]'), email = (ie.value || '').trim().toLowerCase();
      ie.classList.remove('is-mal'); ie.removeAttribute('aria-invalid'); err.textContent = '';
      if (!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email)) { ie.classList.add('is-mal'); ie.setAttribute('aria-invalid', 'true'); err.textContent = 'Revisa tu correo.'; ie.focus(); return; }
      enviando = true; correo = email;
      var btn = $('.pj-form .pj-cta'), lbl = btn.querySelector('span'); btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); lbl.textContent = 'Aplicando tu ' + PREMIO + '…';
      klaviyo(email, respuesta).then(function (k) { medir('klaviyo', k); }, function () { medir('klaviyo', { r: 'error' }); });
      medir('reclama', { respuesta: respuesta });
      guarda({ rec: new Date().toISOString() });
      var ya = false, alSeguir = function () { if (ya) return; ya = true; if (txt('waActivo', '') === 'true') aWhatsapp(); else listoPaso(); };
      marca().then(function (ok) { medir('atributo', { ok: ok ? 1 : 0 }); alSeguir(); });
      setTimeout(alSeguir, 2500);
    });

    /* ---------- WhatsApp: mismo perfil de Klaviyo y misma lista. Se omite con «Ahora no», con la X o con Esc; el premio ya
       quedó reclamado en el paso del correo, así que nada de aquí lo afecta y nunca se espera a Klaviyo. ---------- */
    function aWhatsapp() {
      var p = paso('whatsapp');
      medir('whatsapp_visto', {});
      enfoca(p, 'input[name="whatsapp"]');
    }
    var enviandoWa = false;
    $('.pj-form-wa').addEventListener('submit', function (e) {
      e.preventDefault();
      if (enviandoWa) return;
      var err = $('#pjErrWa'), iw = $('input[name="whatsapp"]'), caja = $('.pj-tel'), numero = telefono(iw.value);
      caja.classList.remove('is-mal'); iw.removeAttribute('aria-invalid'); err.textContent = '';
      if (!numero) { caja.classList.add('is-mal'); iw.setAttribute('aria-invalid', 'true'); err.textContent = 'Revisa tu número: son 10 dígitos.'; iw.focus(); return; }
      enviandoWa = true;
      klaviyoWhatsapp(correo, numero, respuesta).then(function (k) { medir('klaviyo_whatsapp', k); }, function () { medir('klaviyo_whatsapp', { r: 'error' }); });
      medir('whatsapp_guarda', {});
      listoPaso();
    });
    $('[data-omite]').addEventListener('click', function () { medir('whatsapp_omite', {}); listoPaso(); });

    /* la pantalla final no muestra código: el premio ya está en el pedido por la oferta de la página */
    function listoPaso() {
      var p = paso('listo');
      vibra([10, 50, 18]);
      enfoca(p, '[data-final]');
    }
    $('[data-final]').addEventListener('click', function () {
      medir('final', {});
      var url = txt('urlFinal', '');
      cierra('final', url ? function () { location.href = url; } : null);
    });
  }

  /* ---------- Klaviyo: Client API con la llave pública (Site ID), nunca la privada (pk_…). Dos llamadas:
     1. suscripción con consentimiento de correo a la lista, con las 6 propiedades en el perfil (así el perfil ya las
        trae cuando la lista dispara «Added to list»);
     2. evento «Popup Juego Registro» con las mismas propiedades, para disparar flujos por métrica.
     Sin ID de lista no se manda nada (no hay consentimiento que registrar): se mide como sin_lista. ---------- */
  var KL_REV = '2026-10-15', METRICA = 'Popup Juego Registro';
  function propiedades(respuesta) {
    return { popup_source: 'popup_juego', popup_premio: PREMIO_ID, popup_landing: LANDING, popup_respuesta: respuesta || '',
      popup_fecha: new Date().toISOString(), popup_campana: txt('campana', 'bf26') };
  }
  function cargas(email, respuesta) {
    var pr = propiedades(respuesta);
    return [
      { path: 'subscriptions', body: { data: { type: 'subscription', attributes: { custom_source: 'Popup juego de cartas · ' + LANDING,
        profile: { data: { type: 'profile', attributes: { email: email, properties: pr, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
        relationships: { list: { data: { type: 'list', id: KL.list || '(falta el ID de la lista)' } } } } } },
      { path: 'events', body: { data: { type: 'event', attributes: { properties: pr, unique_id: 'popup_juego|' + PREMIO_ID + '|' + sid(),
        metric: { data: { type: 'metric', attributes: { name: METRICA } } },
        profile: { data: { type: 'profile', attributes: { email: email, properties: pr } } } } } } }
    ];
  }
  /* WhatsApp: el mismo perfil (por correo) y la misma lista, con phone_number en E.164. Va sin consentimiento de SMS: el
     aviso cubre correo y WhatsApp, y Klaviyo guarda el teléfono sin suscribirlo a SMS. El permiso de WhatsApp queda en las
     propiedades popup_whatsapp*, con su fecha y la versión del aviso. */
  var METRICA_WA = 'Popup Juego WhatsApp', AVISO = 'correo_whatsapp_2026-11-03';
  function cargasWhatsapp(email, numero, respuesta) {
    var pr = propiedades(respuesta);
    pr.popup_whatsapp = true; pr.popup_whatsapp_fecha = new Date().toISOString(); pr.popup_consentimiento = AVISO;
    return [
      { path: 'subscriptions', body: { data: { type: 'subscription', attributes: { custom_source: 'Popup juego de cartas · ' + LANDING + ' · WhatsApp',
        profile: { data: { type: 'profile', attributes: { email: email, phone_number: numero, properties: pr, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
        relationships: { list: { data: { type: 'list', id: KL.list || '(falta el ID de la lista)' } } } } } },
      { path: 'events', body: { data: { type: 'event', attributes: { properties: pr, unique_id: 'popup_juego_wa|' + PREMIO_ID + '|' + sid(),
        metric: { data: { type: 'metric', attributes: { name: METRICA_WA } } },
        profile: { data: { type: 'profile', attributes: { email: email, phone_number: numero, properties: pr } } } } } } }
    ];
  }
  /* audiencia por promo (pedido de Mau, 2026-11-03): además de la lista general, la misma suscripción a la lista de la
     promo de la página (50% y home: Swfqtc · 2x1: VpsSw9), de donde sale sola la audiencia. Va justo después de la
     general; si no hay lista de promo o es la misma, no se duplica. */
  function conPromo(j) {
    j[0].rol = 'sub'; j[1].rol = 'evento';
    if (!KL.listaPromo || KL.listaPromo === KL.list) return j;
    var p = JSON.parse(JSON.stringify(j[0]));
    p.rol = 'subPromo';
    p.body.data.attributes.custom_source += ' · audiencia';
    p.body.data.relationships.list.data.id = KL.listaPromo;
    return [j[0], p, j[1]];
  }
  function cargasTodas(email, respuesta) { return conPromo(cargas(email, respuesta)); }
  function klaviyo(email, respuesta) { return mandaCargas(cargasTodas(email, respuesta)); }
  function klaviyoWhatsapp(email, numero, respuesta) { return mandaCargas(conPromo(cargasWhatsapp(email, numero, respuesta))); }
  function mandaCargas(j) {
    if (DRY) {
      try { console.info('[popup-juego] modo dry: Klaviyo no se llama (company_id=' + (KL.company || 'vacío') + ', lista=' + (KL.list || 'vacía') + ', lista de la promo=' + (KL.listaPromo || 'vacía') + ')', JSON.stringify(j)); } catch (e) {}
      return Promise.resolve({ r: 'dry' });
    }
    if (!KL.company) return Promise.resolve({ r: 'sin_klaviyo' });
    if (!KL.list) { try { console.warn('[popup-juego] falta el ID de la lista de Klaviyo: el correo no se guardó'); } catch (e) {} return Promise.resolve({ r: 'sin_lista' }); }
    var manda = function (c) {
      return conTiempo(fetch(KL.base + c.path + '?company_id=' + encodeURIComponent(KL.company), { method: 'POST', keepalive: true,
        headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': KL_REV }, body: JSON.stringify(c.body) })
        .then(function (r) { return r.status; }, function () { return 'red'; }), 10000).then(null, function () { return 'tiempo'; });
    };
    var bien = function (st) { return typeof st === 'number' && st >= 200 && st < 300; };
    return Promise.all(j.map(manda)).then(function (x) {
      var o = { r: x.every(bien) ? 'ok' : 'error' };
      j.forEach(function (c, i) { o[c.rol] = String(x[i]); });
      return o;
    });
  }

  /* ---------- atributo oculto del carrito: _popup_juego = <premio>|reclamo (sin código: el total no cambia).
     /cart/update.js solo con attributes suma esa clave a las que ya hay (_lnd, _oferta, ref); un reintento; nunca deja
     a nadie atorado ---------- */
  function marca() {
    if (!PREMIO_ID) return Promise.resolve(false);
    var una = function () { return conTiempo(jpost(RAIZ + 'cart/update.js', { attributes: { _popup_juego: PREMIO_ID + '|reclamo' } }), 6000); };
    return una().then(null, function () { return una(); }).then(function () { return true; }, function () { return false; });
  }

  /* API mínima: PopupJuego.abre() lo abre a mano (p. ej. desde un botón «Prueba tu suerte») */
  window.PopupJuego = {
    brazo: brazo,
    reclamado: reclamado,
    abre: function () { if (abierto) return; FORZADO = true; hecho = false; intenta('manual'); },
    _reparto: reparto,
    _cargas: cargasTodas,
    _cargasWhatsapp: cargasWhatsapp,
    _telefono: telefono,
    _oportunidades: oportunidades
  };
})();
